var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'd-flex flex-column rounded-lg',
    { 'border-gray': !_vm.noBorder, 'px-6 py-4': !_vm.small && !_vm.noPadding, 'px-3 py-2': _vm.small && !_vm.noPadding },
  ],style:(`${!!_vm.borderColor && !_vm.noBorder ? `border-color: ${_vm.borderColor}` : ''}`)},[(!!_vm.content)?_c('form-node',_vm._g(_vm._b({},'form-node',_vm.content,false),_vm.$listeners)):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }